var _rect, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadsMenuIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 7,
    fill: "#11041E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.257 36.1767H36.0378C36.6859 36.1767 37.2823 35.9556 37.7559 35.5848C37.8036 35.5474 37.8552 35.5152 37.9104 35.4904C40.7773 34.2047 42.7742 31.3257 42.7742 27.9803C42.7742 23.437 39.0911 19.7539 34.5477 19.7539C34.2371 19.7539 33.9305 19.7711 33.6289 19.8046C33.2672 19.8448 32.9274 19.6008 32.8493 19.2455C32.0381 15.5548 28.7488 12.793 24.8145 12.793C20.8549 12.793 17.5487 15.5905 16.7645 19.3168C16.7111 19.5703 16.4855 19.7539 16.2265 19.7539C11.6831 19.7539 8 23.437 8 27.9803C8 31.98 10.8544 35.313 14.6372 36.0534C14.8971 36.1335 15.1733 36.1767 15.4596 36.1767H15.5172C15.751 36.1966 15.9875 36.2068 16.2265 36.2068C16.4654 36.2068 16.702 36.1966 16.9357 36.1767H33.8384C34.0722 36.1966 34.3088 36.2068 34.5477 36.2068C34.7866 36.2068 35.0232 36.1966 35.257 36.1767Z",
    fill: "url(#paint0_linear_1433_12760)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 22.9176L22.3465 29.2457L29.6535 29.2457L26 22.9176ZM26.6328 36.2065L26.6328 28.6129L25.3672 28.6129L25.3672 36.2065L26.6328 36.2065Z",
    fill: "#240E3F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1433_12760",
    x1: 20.5,
    y1: 5.99988,
    x2: 15.8184,
    y2: 35.1682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C070FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C117C"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadsMenuIcon);
export default __webpack_public_path__ + "static/media/uploadsMenuIcon.b4af3f69aa7d7be07e7bd578a1646f62.svg";
export { ForwardRef as ReactComponent };